<div class="blue-bg mt-5r esr-div">
  <div class="esr-row">
    <div class="image-column">
      <img class="h-100" src="assets/images/services/third-party-recycling-ethical-responsible-sustainable.jpg" alt="3PR™ Services - Ethical-Responsible-Sustainable">
    </div>

    <div class=" h-100 text-column">
      <div class="align-items-center">
        <div class="">
          <h1>
            {{ersHeadline}}
          </h1>
          <div class="mt-3">
            For more than a century, Radius has been developing robust networks to collect, process, and deliver recycled metals to customers in North America and around the world. 
          </div>

          <div class="mt-3">
            Recognized by global organizations for leading performance in sustainability, ethics, and responsible operations, Radius was named by Ethisphere as one of the World's Most Ethical Companies of 2024 - a distinction we have maintained for the past decade.
          </div>

          <div class="mt-3">
            Our 3PR™ Services meet the growing demand from companies, organizations, and other entities to increase recycling rates and value recovery, improve manufacturing and retail efficiency, reduce material going to landfill, and address industrial carbon footprints. 
          </div>
          <a (click)="openThreePrForm()" class="btn btn-secondary mt-3">Contact Us</a>
        </div>
      </div>
    </div>
  </div>
</div>
